import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({ providedIn: 'root' })
export class GetBlogDataGqlService {
  readonly document = gql`
    query GetBlogData {
      blogPosts(orderBy: date_DESC) {
        title
        slug
        date
        tags {
          name
        }
        content
        images {
          url
        }
      }
    }
  `;
}
